import "core-js/modules/es6.regexp.search.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.date.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { URLSearchParameters } from "../Shared/URLSearchParameters";
export var CommonBuilder = /*#__PURE__*/function () {
  function CommonBuilder() {
    _classCallCheck(this, CommonBuilder);
  }

  _createClass(CommonBuilder, null, [{
    key: "GetId",
    value: function GetId() {
      var idParameterName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var urlParams = new URLSearchParameters(window.location.search);
      var id = urlParams.get(idParameterName !== null && idParameterName !== void 0 ? idParameterName : "id") || this.ParseFromPath(urlParams.toString());
      return +id;
    }
  }, {
    key: "GetInvoiceId",
    value: function GetInvoiceId() {
      var urlParams = new URLSearchParameters(window.location.search);
      var id = urlParams.get("invoiceid");
      return id;
    }
  }, {
    key: "ParseFromPath",
    value: function ParseFromPath(queryString) {
      //let locationWithoutQueryString = location.href.replace(`?${queryString}`, '');
      console.log('location.href', location.href);
      var locationWithoutQueryString = location.href.split("?")[0];
      var urlArray = locationWithoutQueryString.split('/'); //let id = location.href.endsWith("/") ? urlArray[urlArray.length - 2] : urlArray[urlArray.length - 1];

      var id = urlArray[urlArray.length - 1] != "" ? urlArray[urlArray.length - 1] : urlArray[urlArray.length - 2];
      return +id;
    }
  }, {
    key: "isMobile",
    value: function isMobile() {
      var match = window.matchMedia || window.msMatchMedia;

      if (match) {
        var mq = match("(pointer:coarse)");
        return mq.matches;
      }

      return false;
    }
  }]);

  return CommonBuilder;
}();